var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
var validate = ref.validate;
var reset = ref.reset;
return [_c('form',{attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.submitForm)}}},[_vm._t("default",null,{"validate":validate,"reset":reset})],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }